<div class="dimg">

  <!-- Selettore file per il caricamento: aperto dal bottone "Carica immagine" nell'intestazione della card -->
  <input type="file" #fileInput class="d-none" [accept]="uploadAccept" (change)="onFileSelected($event)">

  <!-- Caricamento -->
  <div class="dimg-state" *ngIf="isLoading">
    <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Caricamento...</span></div>
    <p class="dimg-state-text">Caricamento immagini...</p>
  </div>

  <!-- Errore -->
  <div class="dimg-state" *ngIf="!isLoading && errorMessage">
    <i class="fas fa-exclamation-circle fa-3x text-danger"></i>
    <p class="dimg-state-text">{{ errorMessage }}</p>
    <button type="button" class="btn btn-primary btn-sm" (click)="load()">
      <i class="fas fa-redo-alt me-1"></i> Riprova
    </button>
  </div>

  <!-- Sezione vuota -->
  <div class="dimg-state" *ngIf="!isLoading && !errorMessage && images.length === 0">
    <i class="fas fa-images fa-3x"></i>
    <p class="dimg-state-text">Nessuna immagine disponibile per questa pratica.</p>
    <small class="dimg-state-sub" *ngIf="parcelCode">Non risultano immagini o documenti per il collo <strong>{{ parcelCode }}</strong>.</small>
    <button type="button" class="btn btn-primary btn-sm" *ngIf="canUpload" (click)="openFilePicker()"
            [disabled]="isUploading" title="Carica un'immagine o un PDF del danno sul collo">
      <i class="fas" [ngClass]="isUploading ? 'fa-spinner fa-spin' : 'fa-upload'"></i> Carica immagine
    </button>
  </div>

  <ng-container *ngIf="!isLoading && !errorMessage && images.length > 0">

    <!-- Toolbar: riepilogo + vista -->
    <div class="dimg-toolbar">
      <div class="dimg-summary">
        <i class="fas fa-images"></i>
        <span><strong>{{ images.length }}</strong> {{ images.length === 1 ? 'immagine' : 'immagini' }}</span>
        <span class="dimg-summary-sep" *ngIf="parcelCode">·</span>
        <span *ngIf="parcelCode">collo <strong>{{ parcelCode }}</strong></span>
      </div>
      <div class="dimg-view-toggle" role="group" aria-label="Modalità di visualizzazione">
        <button type="button" class="dimg-view-btn" [class.active]="viewMode === 'grid'"
                (click)="viewMode = 'grid'" title="Vista compatta a griglia">
          <i class="fas fa-th-large"></i><span>Compatta</span>
        </button>
        <button type="button" class="dimg-view-btn" [class.active]="viewMode === 'list'"
                (click)="viewMode = 'list'" title="Vista lista, una sotto l'altra">
          <i class="fas fa-stream"></i><span>Lista</span>
        </button>
      </div>
    </div>

    <!-- Vista compatta (griglia) -->
    <div class="images-grid" *ngIf="viewMode === 'grid'">
      <div class="image-card" *ngFor="let image of images; trackBy: trackByImage" (click)="openPreview(image)">
        <div class="image-card-thumb">
          <img *ngIf="src(image)" [src]="src(image)" [alt]="image.imageFileName || 'Immagine'" loading="lazy">
          <div class="image-card-placeholder" *ngIf="!src(image)">
            <i class="fas" [ngClass]="isPdf(image) ? 'fa-file-pdf' : 'fa-image'"></i>
          </div>
          <span class="image-type-badge">{{ typeLabel(image) }}</span>
          <button type="button" class="image-action-btn image-card-download" (click)="download(image, $event)" title="Scarica il file">
            <i class="fas fa-download"></i>
          </button>
        </div>
        <div class="image-card-info">
          <span class="image-card-name" [title]="image.imageFileName">{{ image.imageFileName || '-' }}</span>
          <span class="image-card-date" *ngIf="image.imageCreatedAt">{{ image.imageCreatedAt | date:'dd/MM/yy HH:mm' }}</span>
        </div>
      </div>
    </div>

    <!-- Vista lista -->
    <div class="images-list" *ngIf="viewMode === 'list'">
      <div class="image-list-item" *ngFor="let image of images; trackBy: trackByImage">
        <div class="image-list-preview" (click)="openPreview(image)"
             [title]="isPdf(image) ? 'Apri il documento' : 'Apri l\'anteprima'">
          <img *ngIf="src(image)" [src]="src(image)" [alt]="image.imageFileName || 'Immagine'" loading="lazy">
          <div class="image-card-placeholder" *ngIf="!src(image)">
            <i class="fas" [ngClass]="isPdf(image) ? 'fa-file-pdf' : 'fa-image'"></i>
          </div>
        </div>
        <div class="image-list-info">
          <div class="dimg-item-head">
            <span class="dimg-item-title">{{ image.imageFileName || typeLabel(image) }}</span>
            <span class="dimg-item-date" *ngIf="image.imageCreatedAt">
              <i class="far fa-clock me-1"></i>{{ image.imageCreatedAt | date:'dd/MM/yyyy HH:mm' }}
            </span>
          </div>
          <div class="dimg-item-meta">
            <span class="dimg-type-pill">{{ typeLabel(image) }}</span>
            <span *ngIf="image.imageSource"><i class="fas fa-server"></i>{{ image.imageSource }}</span>
            <span *ngIf="image.imageSizeBytes"><i class="fas fa-weight-hanging"></i>{{ formatSize(image.imageSizeBytes) }}</span>
            <span *ngIf="image.imageCreatedBy"><i class="fas fa-user"></i>{{ image.imageCreatedBy }}</span>
            <span *ngIf="image.imageWaybillCode"><i class="fas fa-barcode"></i>{{ image.imageWaybillCode }}</span>
          </div>
          <p class="dimg-item-note" *ngIf="image.imageDescription">
            <i class="fas fa-sticky-note me-1"></i>{{ image.imageDescription }}
          </p>
          <div class="image-list-actions">
            <button type="button" class="image-action-btn" (click)="openPreview(image)"
                    [title]="isPdf(image) ? 'Apri il documento' : 'Apri l\'anteprima'">
              <i class="fas" [ngClass]="isPdf(image) ? 'fa-external-link-alt' : 'fa-search-plus'"></i>
            </button>
            <button type="button" class="image-action-btn" (click)="download(image, $event)" title="Scarica il file">
              <i class="fas fa-download text-primary"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

  </ng-container>

  <!-- Anteprima a schermo intero -->
  <div class="image-preview-overlay" *ngIf="previewImage" (click)="closePreview()">
    <div class="image-preview-content" (click)="$event.stopPropagation()">
      <div class="image-preview-header">
        <span class="image-preview-title">
          <span class="dimg-type-pill me-2">{{ typeLabel(previewImage) }}</span>{{ previewImage.imageFileName || '' }}
        </span>
        <div class="image-preview-actions">
          <button type="button" class="image-action-btn" (click)="download(previewImage, $event)" title="Scarica il file">
            <i class="fas fa-download text-primary"></i>
          </button>
          <button type="button" class="image-action-btn" (click)="closePreview()" title="Chiudi anteprima">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
      <div class="image-preview-body">
        <img [src]="src(previewImage)" [alt]="previewImage.imageFileName || 'Immagine'">
      </div>
    </div>
  </div>

</div>
